import { gql, type TypedDocumentNode } from '@apollo/client';

import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { CollectMissionsDialog } from '#src/components/missions/CollectMissionsDialog/index.tsx';

import type {
  SetCollectMissionsDialogQuery,
  SetCollectMissionsDialogQueryVariables,
} from './__generated__/index.graphql.ts';

const COLLECT_MISSIONS_DIALOG_QUERY = gql`
  query SetCollectMissionsDialogQuery($sport: Sport!) {
    currentUser {
      slug
      setCollectionsTaskTracks(sport: $sport) {
        id
        ...CollectionMissions_taskInterface
      }
    }
  }
  ${CollectMissionsDialog.fragments.taskInterface}
` as TypedDocumentNode<
  SetCollectMissionsDialogQuery,
  SetCollectMissionsDialogQueryVariables
>;

type Props = {
  open: boolean;
  onClose: () => void;
};

export const SetCollectMissionsDialog = ({ open, onClose }: Props) => {
  const { sport } = useSportContext();
  const { data } = useQuery(COLLECT_MISSIONS_DIALOG_QUERY, {
    variables: { sport },
    skip: !open,
  });

  const tasks = data?.currentUser?.setCollectionsTaskTracks ?? [];

  return <CollectMissionsDialog tasks={tasks} open={open} onClose={onClose} />;
};
